export const technologyConstants = {
  SET_TECHNOLOGY_FIELD: 'SET_TECHNOLOGY_FIELD',
  SELECT_TECHNOLOGY_FIELD: 'SELECT_TECHNOLOGY_FIELD',
  RESET_TECHNOLOGY_STORE: 'RESET_TECHNOLOGY_STORE',
  SET_IS_TV_AD: 'SET_IS_TV_AD',
  VALIDATE_TECHNOLOGY_STORE: 'VALIDATE_TECHNOLOGY_STORE',
};
